module.exports = __webpack_public_path__ + "img/bottelegram.a16d7a7b.png";